import React from 'react'
import PropTypes from 'prop-types'
import { CMSContent, MediaQuery, styled } from '@deseretbook/react-ui'
import { getInfo } from '@deseretbook/cms'
import { Conditional } from '../../core'
import { useMediaQuery, useUserPermission } from '../'

const StyledIframeContainer = styled('div')(({
  theme,
  type,
  width,
  height,
}) => ({
  margin: 'auto', // Center content horizontally
  // Limit size of videos
  ...(!!(type === 'video') && {
    maxWidth: theme.spacing.use(50),
  }),
  // Reserve space for iframe content.
  '> div': {
    position: 'relative',
    paddingTop: `${(height / width) * 100}%`,
  },
  iframe: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  },
}))

/**
 * An EmbeddedContent component that renders embedded_content slices. This component supports
 * the following slice types:
 * - embedded_content_v1
 *
 * @returns {function} Component
 */
const EmbeddedContent = ({ slice, user }) => {
  const { type } = getInfo(slice)
  const { embed } = slice.primary || {}

  if (type !== 'embedded content' || !(embed && embed.html)) {
    return false
  }
  const mediaQuery = useMediaQuery(slice.primary && slice.primary.mediaQuery)
  const userPermission = useUserPermission(slice.primary && slice.primary.userPermission, user)

  const isLoading = mediaQuery.isLoading || userPermission.isLoading

  if (!userPermission.hasPermission || isLoading) {
    return false
  }

  return (
    <Conditional
      condition={Object.keys(mediaQuery.mediaQuery).length}
      component={MediaQuery}
      props={mediaQuery.mediaQuery}
    >
      <StyledIframeContainer height={embed.height} width={embed.width} type={embed.type}>
        <CMSContent
          itsNotDangerousBecause="This html was generated by Prismic and Prismic doesn't allow writing html in their editor. 😎"
          dangerouslySetInnerHTML={{
            __html: slice.primary.embed.html,
          }}
        />
      </StyledIframeContainer>
    </Conditional>
  )
}

EmbeddedContent.propTypes = {
  slice: PropTypes.shape({
    sliceType: PropTypes.string,
    primary: PropTypes.shape({
      embed: PropTypes.shape({
        html: PropTypes.string,
        embedUrl: PropTypes.string,
      }),
      subtitle: PropTypes.string,
    }),
  }),
  user: PropTypes.shape({}),
}

EmbeddedContent.defaultProps = {
  slice: {},
  user: null,
}

export default EmbeddedContent
